import { usePathname, useSearchParams } from 'next/navigation';

export const useCurrentPath = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const currentPath = pathname + (searchParams?.toString() ? `?${searchParams.toString()}` : '');

  return encodeURIComponent(currentPath);
};
